(() => {
  function init(root) {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const strings=JSON.parse(root.querySelector('[data-sale-strings]').textContent);
    const grid=root.querySelector('[data-sale-grid]');
    if(!grid) return;
    const cards=[...grid.querySelectorAll('[data-sale-card]')];
    const filters=[...root.querySelectorAll('[data-filter]')];
    const sort=root.querySelector('[data-sale-sort]');
    let selected='all';
    function update(){
      const ordered=[...cards].sort((a,b)=>sort.value==='saving'?Number(b.dataset.saving)-Number(a.dataset.saving):sort.value==='price'?Number(a.dataset.price)-Number(b.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));
      ordered.forEach(card=>{card.hidden=selected!=='all'&&card.dataset.kind!==selected;grid.append(card)});
      const count=cards.filter(card=>!card.hidden).length;
      root.querySelector('[data-result-count]').textContent=count+' '+strings.wines;
      root.querySelector('[data-sale-empty]').hidden=count>0;
    }
    filters.forEach(button=>button.addEventListener('click',()=>{selected=button.dataset.filter;filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));update()}));
    sort.addEventListener('change',update);
    const toast=root.querySelector('[data-sale-toast]');
    root.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
      const input=button.form.elements.quantity;
      const current=Number(input.value)||1;
      input.value=Math.min(Number(input.max)||Infinity,Math.max(1,current+Number(button.dataset.quantityStep)));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    root.querySelector('[data-toast-close]').addEventListener('click',()=>toast.hidden=true);
    root.querySelectorAll('[data-sale-form]').forEach(form=>form.addEventListener('submit',async event=>{
      if(!event.submitter || typeof window.__ottoSubmitProductForm !== 'function') return;
      event.preventDefault();
      const button=event.submitter, label=button.innerHTML;
      const quantity=Number(form.elements.quantity.value);
      if(!form.reportValidity() || !Number.isInteger(quantity) || quantity<1) return;
      const body=new FormData(form);
      const controls=[...form.querySelectorAll('button, input[name="quantity"]')];
      const disabledStates=controls.map(b=>b.disabled);
      controls.forEach(b=>b.disabled=true); button.textContent=strings.adding;
      try {
        toast.hidden=true;
        await window.__ottoSubmitProductForm(form,button,body);
      }
      finally{controls.forEach((b,i)=>b.disabled=disabledStates[i]);button.innerHTML=label;}
    }));
    update();
  }
  document.querySelectorAll('[data-os-sale]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-os-sale]').forEach(init));
})();
